<template>
  <Login></Login>
  <!-- <Register></Register> -->
</template>

<script>
import Login from '@/components/Login.vue'
// import Register from '@/components/Register.vue';
export default {
    name:'login-page',
    components: {
        Login,
        // Register
    }
}
</script>

<style>

</style>